import { render } from "./Bio.vue?vue&type=template&id=2aeb3ff6"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Keith\\source\\michaelslyfescheme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__